export default __webpack_public_path__ + "static/media/watch.26dc7d65.png";